import { Injectable } from '@angular/core';
import { Subscription, Observable, Subject, timer } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class TimersService {
  private _count = 0;
  private _timeoutMillisecondSession = 1000 * 60 * 50;
  private _timeoutMillisecondToken = 1000 * 60 * 60; // colocar el tiempo de duracion de la sesion.
  private timerSubscription: Subscription = new Subscription();
  private timerSubscriptionToken: Subscription = new Subscription();
  private _timer: Observable<number> = new Observable();
  private resetOnTrigger: boolean = false;
  public timeoutExpired: Subject<number> = new Subject<number>();

  acction = false;

  constructor(private readonly authService: AuthService) {
    this.timeoutExpired.subscribe((_n) => {});
  }

  async resetTimmer() {
    const curus = this.authService.currentUserValue;

    if (curus != null) {
      this.acction = true;
      this.startTimer();
    }
  }

  private setSubscription() {
    // timer de accion sobre ventana se reinica cada vez que existe accion
    this._timer = timer(this._timeoutMillisecondSession);
    this.timerSubscription = this._timer.subscribe((n) => {
      this.timerComplete(n);
    });
  }

  setSubscriptionToken() {
    //timer de token se setea al ingresar
    this._timer = timer(this._timeoutMillisecondToken);
    this.timerSubscriptionToken = this._timer.subscribe((n) => {
      this.timerCompleteToken(n);
    });
  }

  public startTimerToken() {
    if (this.timerSubscriptionToken) {
      this.stopTimerToken();
    }
    this.setSubscriptionToken();
  }

  public startTimer() {
    if (this.timerSubscription) {
      this.stopTimer();
    }
    this.setSubscription();
  }

  public stopTimer() {
    this.timerSubscription.unsubscribe();
  }

  public stopTimerToken() {
    this.timerSubscriptionToken.unsubscribe();
  }

  public resetTimer() {
    this.startTimer();
  }

  public forcedTimeout() {
    this.timeoutExpired.next(2400000);
  }

  public timerComplete(n: number) {
    this.acction = false;
    this.timeoutExpired.next(++this._count);

    if (this.resetOnTrigger) {
      this.startTimer();
    }
  }

  public timerCompleteToken(n: number) {
    if (this.acction) {
      //  this.authService.refreshToken();
    }
  }
}
